module.exports = __webpack_public_path__ + "img/xiaohongshu.2ffd15d.png";